import { Component } from '@angular/core';

@Component({
    selector: '[account-sidebar]',
    templateUrl: './account-sidebar.component.html',
    standalone: false
})
export class AccountSidebarComponent {}
